import useCancel from "@/hooks/use-cancel";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IOrderCancelInput } from "@/interfaces/order.interfaces";
import orderService from "@/services/order.service";
import { CancelRequestProps } from "@/types/requests.types";

export type Return = {
  cancel: (input: CancelRequestProps<IOrderCancelInput>) => Promise<IOrderCancelInput>;
} & UseLoadingReturn;

const useCancelOrder = (): Return => {
  const fetcher = useCancel<IOrderCancelInput>({
    operation: async (i) => {
      return await orderService.cancel(i);
    },
  });

  const { isLoading, startLoading, endLoading, loadingIcon, cancel } = fetcher;

  return { isLoading, startLoading, endLoading, loadingIcon, cancel };
};
export default useCancelOrder;
